export class Information {
    constructor(information_id, solution_id, timestamp, value) {
        this.information_id = information_id;
        this.solution_id = solution_id;
        this.timestamp = timestamp;
        this.value = value;
    }
}
